import React from "react";
import { useQuery } from "@tanstack/react-query";
import { getBatchFiles } from "../../../../services/FileUploadService";
import { Container, Table, Spinner, Alert } from "react-bootstrap";

const BatchList = ({ batchId }) => {
    const { data: batchFiles, isFetching } = useQuery({
        queryKey: ["batchFiles", batchId],
        queryFn: () => getBatchFiles(batchId),
        enabled: !!batchId,
    });

    return (
        <Container className="mt-4">
            <h4>Batch: {batchId}</h4>
            {isFetching && <Spinner animation="border" size="sm" />}
            {batchFiles && batchFiles.length > 0 ? (
                <Table bordered hover className="mt-2">
                    <thead>
                        <tr>
                            <th>File Name</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {batchFiles.map((file) => (
                            <tr key={file.id}>
                                <td>{file.originalFileName}</td>
                                <td>
                                    <Alert variant={file.status === "COMPLETED" ? "success" : "warning"}>{file.status}</Alert>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            ) : (
                <Alert variant="info">No files uploaded yet.</Alert>
            )}
        </Container>
    );
};

export default BatchList;
